import { render, staticRenderFns } from "./MatchingQuestionInput.vue?vue&type=template&id=047248ac&scoped=true"
import script from "./MatchingQuestionInput.vue?vue&type=script&lang=js"
export * from "./MatchingQuestionInput.vue?vue&type=script&lang=js"
import style0 from "./MatchingQuestionInput.vue?vue&type=style&index=0&id=047248ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047248ac",
  null
  
)

export default component.exports